const CONFIG = {
  API_DOMAIN: process.env.REACT_APP_API_DOMAIN,
  MEDIA_DOMAIN: process.env.REACT_APP_MEDIA_DOMAIN,
  CP_MEDIA_DOMAIN: process.env.REACT_APP_CP_MEDIA_DOMAIN,
  FILE_DOMAIN: process.env.REACT_APP_FILE_DOMAIN,
};

export default CONFIG;
